import React from "react";
import { Link } from "react-router";
import ReactTooltip from "react-tooltip";
import Pagination from "../../components/Pagination";
import axios from "axios";
import moment from "moment";

import { downloadFile } from "../../functions.js";

export default class InvoicesView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            trainer: {},
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0,
            open_invoices: []
        };
    }

    toggleOpenInvoice = (uuid) => {
        let openInvoices = this.state.open_invoices;
        let index = openInvoices.indexOf(uuid);

        if (index === -1) {
            openInvoices.push(uuid);
        } else {
            openInvoices.splice(index, 1);
        }

        this.setState({
            open_invoices: openInvoices
        });
    };

    getResults = (offset) => {
        axios
            .get("/v1/trainers/" + this.props.params.itemID + "/invoices/", {
                params: {
                    offset: offset,
                    ...this.state.activeFilters
                }
            })
            .then((response) => {
                this.setState({
                    resultRows: response.data.results,
                    count: response.data.count,
                    limit: response.data.limit,
                    offset: response.data.offset
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getInitialData = () => {
        // Get competenceprofile data to choose from and the course data itself
        axios
            .all([axios.get("/v1/trainers/" + this.props.params.itemID + "/")])
            .then(
                axios.spread((trainer, invoices) => {
                    this.setState({
                        trainer: trainer.data
                    });
                    this.getResults();
                })
            )
            .catch((error) => {
                console.log(error);
            });
    };

    componentDidMount() {
        this.getInitialData();
    }

    render() {
        let invoiceDetails = [];
        if (this.state.resultRows === false) {
            invoiceDetails.push(
                <tr key={"eventdetails-loading"}>
                    <td colSpan="5">Factuurregels ophalen...</td>
                </tr>
            );
        } else if (this.state.resultRows.length == 0) {
            invoiceDetails.push(
                <tr key={"eventdetails-loading"}>
                    <td colSpan="5">Er zijn nog geen facturen voor deze opleider...</td>
                </tr>
            );
        } else {
            this.state.resultRows.forEach((invoice, index) => {
                if (invoice.invoice_number) {
                    // Invoice is final, offer a download
                    invoiceDetails.push(
                        <tr key={invoice.uuid}>
                            <td width="50">
                                <i
                                    className={`fa fa-${this.state.open_invoices.includes(invoice.uuid) ? "minus" : "plus"} pointer`}
                                    onClick={() => this.toggleOpenInvoice(invoice.uuid)}
                                />
                            </td>
                            <td>
                                <strong style={{ cursor: "pointer" }} onClick={() => this.toggleOpenInvoice(invoice.uuid)}>
                                    Factuur {invoice.invoice_number}
                                </strong>
                            </td>
                            <td
                                width="200"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    downloadFile(invoice.invoice_url);
                                }}
                                className="link link--blue"
                                style={{ cursor: "pointer" }}
                            >
                                <strong>Factuur</strong>
                                <i className="fa fa-download" />
                            </td>
                            <td
                                width="210"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!invoice.attachment?.available) return;
                                    downloadFile(invoice.attachment?.url);
                                }}
                                data-tip={!invoice.attachment?.available ? true : undefined}
                                data-for={!invoice.attachment?.available ? "invoice-attachment" : undefined}
                                className={`${invoice.attachment?.available ? "link link--blue" : "attachment-download-disabled"}`}
                                style={{ cursor: "pointer" }}
                            >
                                <strong>Factuurspecificatie</strong>
                                <i className={`${invoice.attachment?.available ? "fa fa-download" : "fa fa-download attachment-download-disabled"}`} />
                                {!invoice.attachment?.available && (
                                    <ReactTooltip delayShow={125} delayHide={125} id="invoice-attachment" effect="solid">
                                        De factuurspecificatie is beschikbaar voor facturen die definitief zijn en zijn aangemaakt na 17 oktober 2023.
                                    </ReactTooltip>
                                )}
                            </td>

                            <td align="right">
                                <strong>{moment(invoice.invoice_date).format("DD-MM-YYYY")}</strong>
                            </td>
                            <td width="100" align="right">
                                {invoice.amount_dc && <strong>&euro; {parseFloat(invoice.amount_dc).toLocaleString("nl-NL", { minimumFractionDigits: 2 })}</strong>}
                            </td>
                        </tr>
                    );
                } else {
                    // Invoice is in concept
                    // Check for elearning
                    let invoiceSubject = "cursuskosten";
                    let invoiceDate = `Wordt gefactureerd op ${moment(invoice.invoice_date).format("DD-MM-YYYY")}`;

                    invoice.lines.forEach((line, lineIndex) => {
                        if (line.product_type === "e-learning-licenses") {
                            invoiceSubject = "e-learning";
                        }
                    });

                    invoiceDetails.push(
                        <tr key={invoice.uuid}>
                            <td width="50">
                                <i
                                    className={`fa fa-${this.state.open_invoices.includes(invoice.uuid) ? "minus" : "plus"} pointer`}
                                    onClick={() => this.toggleOpenInvoice(invoice.uuid)}
                                />
                            </td>
                            <td colSpan="2">
                                <strong>Nog te factureren</strong> ({invoiceSubject})
                            </td>
                            <td colSpan="2" align="right">
                                <span className="lighter">{invoiceDate}</span>
                            </td>
                            <td width="100" align="right">
                                {invoice.amount_dc && <strong>&euro; {parseFloat(invoice.amount_dc).toLocaleString("nl-NL", { minimumFractionDigits: 2 })}</strong>}
                            </td>
                        </tr>
                    );
                }

                let counter = 0;
                let coursesArray = [];
                let lineDescriptions = [];
                let syncMessageShown = false;

                const ignoredProductTypes = ["course-header"];

                invoice.lines.forEach((line, lineIndex) => {
                    let quantity = line.line_items;

                    if (ignoredProductTypes.includes(line.product_type)) {
                        return;
                    }

                    if (this.state.open_invoices.includes(invoice.uuid)) {
                        if (line.item_description !== null) {
                            invoiceDetails.push(
                                <tr key={`invoice-lineitems-${index}-${lineIndex}-linedesc`}>
                                    <td width="50"></td>
                                    <td colSpan="5">{line.item_description}</td>
                                </tr>
                            );
                            counter++;

                            if (quantity.length > 0 && line.synchronized) {
                                line.line_items.forEach((item, itemIndex) => {
                                    if (!lineDescriptions.includes(item.description) && item.course) {
                                        invoiceDetails.push(
                                            <tr key={`invoice-lineitems-${index}-${lineIndex}-${itemIndex}`}>
                                                <td width="50"></td>
                                                <td className="lighter" colSpan="5">
                                                    <i className="fa fa-angle-right"></i>{" "}
                                                    <Link to={`/courses/edit/${item.course}/students`} target="_blank">
                                                        {item.description}
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                        lineDescriptions.push(item.description);
                                    }
                                });
                                counter++;
                            }
                        }
                    }
                });

                if (this.state.open_invoices.includes(invoice.uuid)) {
                    if (counter === 0 && !syncMessageShown && invoice.invoice_status == "Verwerkt") {
                        invoiceDetails.push(
                            <tr key={"invoice-line-noresults" + invoice.uuid}>
                                <td width="50"></td>
                                <td colSpan="5">Wachten op synchronisatie...</td>
                            </tr>
                        );
                        syncMessageShown = true;
                    }
                }
                counter = 0;
            });
        }
        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/trainers"}>Facturen</Link>
                    </div>
                    <h1>{this.state.trainer.name || "..."}</h1>
                    {this.state.editMode && invoiceAllowed && this.state.name !== "" ? (
                        <div className="section-buttons">
                            <Link to={`/trainers/invoices/${this.props.params.itemID}`} className="btn btn-primary">
                                Bekijk alle facturen
                            </Link>
                        </div>
                    ) : (
                        false
                    )}
                </div>

                <div className="mt-3 mb-5">
                    <table className="table">
                        <tbody>{invoiceDetails}</tbody>
                    </table>

                    <Pagination count={this.state.count} limit={this.state.limit} offset={this.state.offset} pageSwitch={(i) => this.getResults(i)} />
                </div>
            </div>
        );
    }
}
